
import { Card, CardActionArea, Link, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { getQueryString } from 'saga/search/utils';

import { LazyContent } from 'evee-ui-common/components/base';

import styles from './styles';

const LocationCard = ({ location, tripDates, loading, classes }) => {
  const { name, thumbnail, vehiclesCount } = location;
  const query = getQueryString(location, { ...tripDates, flexibleDates: true });

  const cardJsx = (
    <Link to={`/search?${query}`} underline="none" component={NavLink}>
      <Card elevation={0}>
        <CardActionArea className={classes.actionArea}>
          <LazyContent>
            <img src={thumbnail} alt={`Rent an electric car in ${name} with evee`} className={classes.image} />
          </LazyContent>
        </CardActionArea>
        <Typography variant="h5" className={classes.cityName}>
          {name}
        </Typography>
        <Typography variant="caption">
          {vehiclesCount} {vehiclesCount > 1 ? 'cars' : 'car'} available
        </Typography>
      </Card>
    </Link>
  );

  const skeletonJsx = <Skeleton variant="rect" width="95%" height="190px" />;

  return loading ? skeletonJsx : cardJsx;
};

LocationCard.propTypes = {
  location: PropTypes.object,
  tripDates: PropTypes.object,
  loading: PropTypes.bool,
  classes: PropTypes.shape({
    cityName: PropTypes.string.isRequired,
    actionArea: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  }).isRequired,
};

LocationCard.defaultProps = {
  location: {},
  tripDates: {},
  loading: false,
};

export default withStyles(styles)(LocationCard);
